import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { ProjectRootAssetId } from '../../../gql/generated/ProjectRootAssetId';
import type { FolderGetLinkParams } from '../../../routing/pages/folder';
import type { TrashGetLinkParams } from '../../../routing/pages/trash';

export const useCheckIsDestinationProjectRoot = () => {
  const { cache } = useApolloClient();

  return useCallback(
    (destination?: FolderGetLinkParams | TrashGetLinkParams) => {
      if (!destination || !destination.projectId) return false;

      const folderAssetId =
        'folderAssetId' in destination ? destination.folderAssetId : undefined;

      if (!folderAssetId) return false;

      const rootAssetId = cache.readFragment({
        fragment: ProjectRootAssetId,
        fragmentName: 'ProjectRootAssetId',
        id: cache.identify({
          __typename: 'Project',
          id: destination.projectId,
        }),
      })?.rootAssetId;

      return rootAssetId === folderAssetId;
    },
    [cache]
  );
};
